import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Videos } from './components/Videos';
import { Gallery } from './components/Gallery';
import { TourDates } from './components/TourDates';
import { BookingForm } from './components/BookingForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-tx-primary text-tx-cream selection:bg-tx-red selection:text-tx-cream" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Videos data-id="element-5" />
        <Gallery data-id="element-6" />
        <TourDates data-id="element-7" />
        <BookingForm data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}